import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import agentBrokerage from '@/agent/components/agentbrokerage/agent-brokerage.vue';
import agentWorkflow from '@/agent/components/agentworkflow/agent-workflow.vue';
import agentTourlink from '@/agent/components/agenttourlink/agent-tourlink.vue';
import agentConnect from '@/agent/components/agentconnect/agent-connect.vue';
import agentTips from '@/agent/components/agenttips/agent-tips.vue';
import agentBanner from '@/agent/components/agentbanner/agent-banner.vue';
import brokerageBanner from '@/agent/components/brokeragebanner/brokerage-banner.vue';
import agentBar from '@/agent/components/agentbar/agent-bar.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import faqConf from '@/common/store/glb/data.faqs';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';

export default {
    name: 'pageAgentHome',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        agentBar,
        mvtWelcome,
        agentBrokerage,
        agentTips,
        agentBanner,
        agentWorkflow,
        agentTourlink,
        agentConnect,
        brokerageBanner,
        mvtFaq,
        mvtHotleadForm,
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
    },
    data() {
        return {
            faqQuery: faqConf.agents,
            states: [],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    methods: {
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadSup: 'GET STARTED',
                    hotleadTitle: 'Connect with a top-rated local agent',
                    hotleadType: 'PopupHotleadInAgentProfilePage_seller',
                    buttonText: 'Connect with a Top Agent',
                    showZipcode: true,
                    profileUrl: this.glb.cdnUrl + 'vimages/assignedAgent.jpg',
                },
            });
        },
    },
    mounted() {
        if (location.href.indexOf('connectagent=1') >= 0) {
            this.openHotlead();
        }
    },
};
